/**
 * 점검 화면 컴포넌트
 * 점검 중일 때 협력사에게 표시되는 화면
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GetActiveMaintenanceResponseDto } from '../types/maintenance.types';
import { formatDateTime } from '../utils/maintenanceUtils';
import '../styles/MaintenanceScreen.css';

interface MaintenanceScreenProps {
    maintenance: GetActiveMaintenanceResponseDto;
    showDashboardButton?: boolean;
    onDashboardClick?: () => void;
}

export const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({ maintenance, showDashboardButton = false, onDashboardClick }) => {
    const navigate = useNavigate();

    const handleGoToDashboard = () => {
        if (onDashboardClick) {
            onDashboardClick();
        }
        navigate('/dashboard');
    };

    return (
        <div className="maintenance-screen">
            <div className="maintenance-content">
                <div className="maintenance-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="64"
                        height="64"
                    >
                        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
                    </svg>
                </div>
                <h1 className="maintenance-title">시스템 점검 중</h1>
                <p className="maintenance-message">
                    {maintenance.msgContent || '서비스 점검 중입니다. 잠시 후 다시 이용해주세요.'}
                </p>
                <div className="maintenance-schedule">
                    <div className="schedule-item">
                        <span className="schedule-label">점검 시작</span>
                        <span className="schedule-value">{formatDateTime(maintenance.startDate)}</span>
                    </div>
                    <div className="schedule-item">
                        <span className="schedule-label">점검 종료 예정</span>
                        <span className="schedule-value">{formatDateTime(maintenance.endDate)}</span>
                    </div>
                </div>
                <p className="maintenance-notice">
                    점검 시간은 상황에 따라 변경될 수 있습니다.<br />
                    일부 기능이 제한됩니다.
                </p>

                {showDashboardButton && (
                    <button
                        className="maintenance-dashboard-button"
                        onClick={handleGoToDashboard}
                    >
                        대시보드로 이동
                    </button>
                )}
            </div>
        </div>
    );
};

export default MaintenanceScreen;
